import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

const PhoneIcon = ({ color = '#B5BCBD', width = '28px', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 115"
    width={width}
    {...props}
  >
    <path
      fill={color}
      d="M32 6c-4.95 0-9 4.05-9 9v70c0 4.95 4.05 9 9 9h36c4.95 0 9-4.05 9-9V57h14c3.29 0 6-2.71 6-6V33c0-3.29-2.71-6-6-6H77V15c0-4.95-4.05-9-9-9zm0 4h36c2.805 0 5 2.195 5 5v1H27v-1c0-2.805 2.195-5 5-5zm-5 10h46v7H53c-3.29 0-6 2.71-6 6v18c0 3.29 2.71 6 6 6h1v8c.003.728.437 1.438 1.085 1.77.647.334 1.477.276 2.07-.145L70.626 57H73v17H27zm26 11h38c1.143 0 2 .857 2 2v18c0 1.143-.857 2-2 2H70c-.412.002-.822.135-1.156.375L58 61.125V55c0-1.047-.953-2-2-2h-3c-1.143 0-2-.857-2-2V33c0-1.143.857-2 2-2zm7 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm12 0c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm12 0c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM27 78h46v7c0 2.805-2.195 5-5 5H32c-2.805 0-5-2.195-5-5zm23 3c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z"
    />
  </svg>
);

PhoneIcon.propTypes = propTypes;

export default PhoneIcon;
